"use client";
import React from "react";
import Home from ".";
import { MessageCircle, Sunrise, Sun } from "lucide-react";
import Link from "next/link";

const HomePage = () => {
  return (
    <div>
      <Home />
        {/* <Link
          className="fixed bottom-6 right-40 bg-pri text-white px-6 py-3 rounded-full flex items-center justify-center shadow-lg hover:scale-95 transition-transform font-semibold text-sm z-10"
          href="#contact"
        >
          Contact Us
        </Link> */}
      
    </div>
  );
};

export default HomePage;
